import { render, staticRenderFns } from "./VLinkPicture.vue?vue&type=template&id=2915610e&scoped=true&"
import script from "./VLinkPicture.vue?vue&type=script&lang=js&"
export * from "./VLinkPicture.vue?vue&type=script&lang=js&"
import style0 from "./VLinkPicture.vue?vue&type=style&index=0&id=2915610e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2915610e",
  null
  
)

export default component.exports